import {useEffect, useRef} from 'react';
import {useStoredState} from '../../../shared/hooks/useStoredState';

const LOCAL_EXPANDABLE_KEY = baseKey => `${baseKey}-expandable-map-v2`;

export const useExpandableGroups = (grouping, prefKey) => {
	const firstUpdate = useRef(true);

	const [groupExpandedMap, setGroupExpandedMap] = useStoredState(LOCAL_EXPANDABLE_KEY(prefKey), {});

	/**
	 * Returns if a group is expanded
	 *
	 * @param group The group name
	 * @returns {any} Is it expanded
	 */
	const groupExpanded = group => {
		return groupExpandedMap[group];
	};

	/**
	 * This method sets the state of a group expanded.
	 *
	 * It also scrolls the table to the group
	 *
	 * @param group The group name
	 * @param expanded Is the group expanded
	 */
	const setGroupExpanded = (group, expanded) => {
		setGroupExpandedMap(prevState => ({...prevState, [group]: expanded}));
	};

	/**
	 * Effect for resetting the expanded group map when the grouping is changed. NOT run on initial render
	 */
	useEffect(() => {
		if (firstUpdate.current) {
			firstUpdate.current = false;
			return;
		}

		setGroupExpandedMap({});
	}, [grouping]);

	return {
		setGroupExpanded,
		groupExpanded,
	};
};
